import { useCallback } from 'react';

import { useGetLocationGroupsLazy } from '@occc-app/dataAccessLayer/locationGroup/queries';
import { FormInputProps } from '@occc-app/design-system';
import { LazyAutocompleteField, StacksIcon } from '@occc/ui-design-system';
import { LocationGroupFilter, LocationGroupFragment } from '@occc/graphql';

type LocationGroupMultipleSelectProps = {
  name: string;
  inputProps?: FormInputProps;
  label?: string;
};

const mapQueryResponseToRawArray = (
  response: ReturnType<typeof useGetLocationGroupsLazy>['response'],
) => response.data || [];

const mapRawResponseItemToAutocompleteOption = (locationGroup: LocationGroupFragment) => ({
  label: locationGroup.name,
  value: locationGroup.uuid,
  _raw: locationGroup,
});

export const LocationGroupMultipleSelect = ({
  name,
  inputProps,
  label,
}: LocationGroupMultipleSelectProps) => {
  const makeQueryFilter = useCallback((inputValue: string) => {
    const filter: LocationGroupFilter = {
      search: inputValue ? inputValue : undefined,
    };

    return filter;
  }, []);

  return (
    <LazyAutocompleteField
      name={name}
      label={label ?? 'Select Location Groups'}
      inputProps={inputProps}
      useLazyQuery={useGetLocationGroupsLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawResponseItemToAutocompleteOption}
      chipPropsIcon={StacksIcon}
    />
  );
};
